import { ReactElement } from 'react'

import { Badge } from 'antd'
import { useTranslation } from 'react-i18next'

import { Icon } from 'components/core'

import { NavButton } from './NavButton'

interface WhatsNewNavItemProps {
    hasUnseenEntry: boolean
    onClick: () => void
}

export const WhatsNewNavItem = ({
    hasUnseenEntry,
    onClick,
}: WhatsNewNavItemProps): ReactElement => {
    const { t } = useTranslation(['common', 'navigation'])

    return (
        <Badge dot={hasUnseenEntry} offset={[-5, 3]} color="red">
            <NavButton
                onClick={onClick}
                tooltipText={t(
                    'navigation:TopNav.WhatsNew.tooltip',
                    "What's New"
                )}
                id="whats-new-nav-button"
            >
                <Icon name="ANNOUNCEMENT" size={18} />
            </NavButton>
        </Badge>
    )
}
